import QuestionBox from "../QuestionBox/QuestionBox";
import QuestionCard from "../QuestionCard/QuestionCard";
import ScoredInputRow from "../ScoredInputRow/ScoredInputRow";
import classes from "./QuestionSection.module.css";

const QuestionSection = ({
  number,
  title,
  questions,
  onAnswerChange,
  answers,
  accreditation,
  topQuestion = true,
  showEmptyNumber,
  showQuestion,
  addWidth,
  disabled,
  showPointsField,
}) => (
  <div className={`${classes.questionsWrapper} d-flex flex-column gap-4 mt-4`}>
    {topQuestion && (
      <div className="d-flex align-items-center gap-2">
        <div className={classes.numberContainer}>{number}</div>
        <QuestionCard question={title} className={classes.questionCardCustom} />
      </div>
    )}

    {questions.map((q, index) => {
      // ✅ Use questionId instead of number
      const questionId = q.questionId || `${number}${q.number || index}`;
      const currentAnswer = answers[questionId] || {};

      return (
        <QuestionBox
          key={questionId}
          number={q.number || ""}
          letter=""
          multilineInput={q.multiline}
          placeholder={q.placeholder}
          question={q.content}
          className={classes.questionContainer}
          value={currentAnswer.comment || ""}
          addWidth={addWidth}
          onChange={(e) =>
            onAnswerChange(
              questionId,
              currentAnswer.score || "",
              e.target.value,
              currentAnswer.points || ""
            )
          }
          showEmptyNumber={showEmptyNumber}
          showQuestion={showQuestion}
          disabled={disabled}
        >
          {q.hideOptions ? (
            ""
          ) : (
            <ScoredInputRow
              accreditation={accreditation}
              className={classes.customInput}
              selectedValue={currentAnswer.score || ""}
              points={currentAnswer.points || ""}
              onAnswerChange={(score, _comment, points) =>
                onAnswerChange(
                  questionId,
                  score,
                  answers[questionId]?.comment || "",
                  points
                )
              }
              showPointsField={showPointsField}
              disabled={disabled}
            />
          )}
        </QuestionBox>
      );
    })}
  </div>
);

export default QuestionSection;
